// رموز الهوية البصرية لتقرير الرواتب — القيم من مواصفات التنفيذ حرفياً.
import { inlineCss, printCss } from "./reportPrintCss";

export const T = {
  primary: "#1e3a2f",
  primaryHover: "#2d5442",
  gold: "#BD9B57",
  danger: "#dc3545",
  positive: "#198754",
  muted: "#666666",
  bgSoft: "#f8f9fa",
  bgExplain: "#f5f5f5",
  borderLight: "#dee2e6",
  warnBg: "#fff3cd",
  warnBorder: "#ffc107",
  warnText: "#856404",
  negInline: "#c00",
  posInline: "#080",
};

export const LEAVE_BADGE = {
  annual: ["#dcfce7", "#16a34a"],
  sick: ["#ffedd5", "#ea580c"],
  emergency: ["#fee2e2", "#dc2626"],
  unpaid: ["#f3f4f6", "#6b7280"],
};

export const css = (compact) => `
* { box-sizing: border-box; }
body { font-family: 'Noto Sans Arabic', 'Noto Kufi Arabic', Arial, sans-serif; font-size: 12px; color: #111; padding: 20px; margin: 0; }
.print-buttons { display: flex; flex-wrap: wrap; gap: 10px; margin-bottom: 16px; }
.print-buttons button { font-family: inherit; font-size: 15px; font-weight: 800; border: 0; cursor: pointer;
  border-radius: 10px; padding: 12px 20px; color: #fff; line-height: 1.2; }
.btn-pdf { background: #4338ca; }
.btn-pdfshare { background: #0f766e; }
@media (max-width: 640px) {
  body { padding: 12px; }
  .print-buttons button { font-size: 17px; padding: 14px 18px; flex: 1 1 46%; }
  .share-bar button { font-size: 16px; padding: 14px 18px; }
}
@media print { .print-buttons, .share-bar { display: none !important; } }
body.exporting .print-buttons, body.exporting .share-bar { display: none !important; }
.btn-print { background: linear-gradient(180deg, #3b82f6, #2563eb);
  display: inline-flex; align-items: center; justify-content: center; gap: 8px; }
.btn-close { background: ${T.danger}; }
.share-bar { display: flex; flex-wrap: wrap; align-items: center; gap: 10px; margin-top: 22px;
  border-top: 2px solid ${T.borderLight}; padding-top: 16px; }
.share-bar button { font-family: inherit; font-size: 12px; font-weight: 700; border: 0; cursor: pointer;
  border-radius: 6px; padding: 10px 18px; color: #fff; }
.btn-share { background: #2563eb; }
.btn-copy { background: ${T.gold}; }
.share-note { font-size: 10px; color: ${T.muted}; }
.refline { text-align: center; font-size: 13px; font-weight: 800; color: ${T.primary};
  margin-bottom: 10px; letter-spacing: 0.4px; }
.refno { font-size: 16px; font-weight: 900; color: ${T.gold}; letter-spacing: 1px; }
.header { position: relative; text-align: center; border-bottom: 2px solid ${T.primary}; padding-bottom: 12px; margin-bottom: 18px; min-height: 120px; }
.brand-logo { position: absolute; inset-inline-start: 0; top: 18px; height: 96px; width: 96px;
  object-fit: cover; border-radius: 12px; background: #fff; display: block; }
.brand-name { font-size: 20px; font-weight: 800; color: ${T.primary}; margin-bottom: 6px; }
.seal { position: absolute; inset-inline-end: 0; top: 0; background: ${T.positive}; color: #fff;
  border-radius: 999px; padding: 4px 10px; font-size: 9px; font-weight: 700; }
.pagebreak { page-break-after: always; break-after: page; }
.pagefoot { text-align: center; font-size: 9px; color: ${T.muted}; padding: 6px 0; }
.sign { margin-top: 22px; border: 1px solid ${T.borderLight}; border-radius: 8px; padding: 12px; }
.sign-title { font-size: 11px; font-weight: 700; color: ${T.primary}; margin-bottom: 10px; }
.sign-row { display: flex; gap: 14px; }
.sign-box { flex: 1; text-align: center; }
.sign-role { font-size: 10px; font-weight: 700; }
.sign-line { border-bottom: 1px solid ${T.text}; height: 34px; margin: 4px 6px 4px; }
.sign-hint { font-size: 8px; color: ${T.muted}; }
.sign-note { margin-top: 8px; font-size: 8px; color: ${T.muted}; }
.header h1 { font-size: 24px; color: ${T.primary}; margin: 0 0 4px; }
.header h2 { font-size: 18px; color: ${T.gold}; margin: 0 0 8px; }
.header p { color: ${T.muted}; margin: 2px 0; }
.header .period { font-weight: 700; color: ${T.primary}; }
.cards { display: grid; grid-template-columns: repeat(4, 1fr); gap: 12px; margin-bottom: 18px; }
.card { background: ${T.bgSoft}; border: 1px solid ${T.borderLight}; border-radius: 8px; padding: 12px; }
.card .label { font-size: 11px; color: ${T.muted}; }
.card .value { font-size: 18px; font-weight: 700; color: ${T.primary}; margin-top: 4px; }
.card .value.negative { color: ${T.danger}; }
.card .value.positive { color: ${T.positive}; }
table { width: 100%; border-collapse: collapse; font-size: ${compact ? "10px" : "11px"}; }
thead th { background: ${T.primary}; color: #fff; padding: ${compact ? "5px" : "7px"} 6px; font-weight: 700; }
tbody td { padding: ${compact ? "4px" : "7px"} 6px; border-bottom: 1px solid ${T.borderLight}; vertical-align: top; }
tbody tr:nth-child(even) { background: ${T.bgSoft}; }
tfoot tr.totals td { background: ${T.primary}; color: #fff; font-weight: 700;
  padding: ${compact ? "5px" : "7px"} 6px; border-top: 2px solid ${T.gold}; }
${inlineCss(T)}
.explain, .warn { border-radius: 8px; padding: 12px 14px; margin-top: 16px; line-height: 1.7; }
.explain { background: ${T.bgExplain}; }
.warn { background: ${T.warnBg}; border: 1px solid ${T.warnBorder}; }
.warn .title { color: ${T.warnText}; font-weight: 700; margin-bottom: 6px; }
.warn ul { margin: 6px 0 0; padding-inline-start: 18px; }
.footer { border-top: 1px solid ${T.borderLight}; margin-top: 18px; padding-top: 8px;
  font-size: 10px; color: ${T.muted}; text-align: center; }
${printCss(compact)}
`;
